import { Component, Fragment } from 'react';
import { Icon, Span, Col, Row } from '@workramp/ui';
import styled from 'styled-components';
import { academyCustomCSS } from '~/constants/academyCustomCSS';
import { media } from '../../../styles';
import academyStyles from './academy-styles';

export default class AcademyBreadcrumb extends Component {
  renderLinks = () => {
    const { links } = this.props;

    return links.map((linkObject, linkIndex) => {
      const link = linkObject.link ? (
        <a href={linkObject.link}>
          <Span>{linkObject.linkText}</Span>
        </a>
      ) : (
        <Span>{linkObject.linkText}</Span>
      );
      const caret = linkIndex === links.length - 1 ? false : <Icon name="caret-right:regular" />;

      return (
        <Fragment key={linkObject.linkText}>
          {link && (
            <Col xs="auto" className={academyCustomCSS.breadcrumbs.breadcrumb} role="listitem">
              {link}
            </Col>
          )}
          {caret && (
            <Col xs="auto" className={academyCustomCSS.breadcrumbs.breadcrumb} role="listitem">
              {caret}
            </Col>
          )}
        </Fragment>
      );
    });
  };

  render() {
    const { linkColor, padding } = this.props;

    return (
      <AcademyBreadcrumbWrapper padding={padding}>
        <AcademyBreadcrumbLinks
          className={academyCustomCSS.breadcrumbs.breadcrumbBar}
          linkColor={linkColor}
          role="list"
        >
          <Row align="center" gapX={2}>
            {this.renderLinks()}
          </Row>
        </AcademyBreadcrumbLinks>
      </AcademyBreadcrumbWrapper>
    );
  }
}

const AcademyBreadcrumbWrapper = styled.div`
  width: calc(100% - ${(props) => (props.padding && props.padding === 'narrow' ? '20rem' : '8rem')});
  padding: 0 ${(props) => (props.padding && props.padding === 'narrow' ? '10rem' : '4rem')};
  ${media.desktopMedium} {
    width: calc(100% - ${(props) => (props.padding && props.padding === 'narrow' ? '12rem' : '8rem')});
    padding: 0 ${(props) => (props.padding && props.padding === 'narrow' ? '6rem' : '4rem')};
  }
  ${media.mobile} {
    padding-left: 2rem;
    padding-right: 2rem;
    width: calc(100% - 4rem);
  }
  @media print {
    display: none;
  }
`;

const AcademyBreadcrumbLinks = styled.div`
  max-width: ${academyStyles.common.maxWidth}px;
  margin: 0 auto;
  padding-top: ${({ theme }) => theme.spacing(8)}px;

  a {
    color: ${(props) => props.linkColor} !important;
  }
`;
